import { Lang } from './lang';

export interface RecentlyViewedResponse {
  data: number[];
  lang: Lang;
  userId: string;
}
